/* src/app/workshop/components/workshop-vehicles/historic-inspections/historic-inspections.component.scss */
/*# sourceMappingURL=historic-inspections.component.css.map */
